<div class="deposit card">
  <div class="close" (click)="dialogRef.close()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>

  <div *ngIf="depositStep === 0" class="inner-container">
    <div class="title-container first-step">
      <h3>Ingresá dinero</h3>
      <p>Seleccioná el tipo de depósito</p>
    </div>

    <div class="options-container">
      <div class="option" (click)="depositStep = 1; depositType = 1">
        <div class="left"><b>Pesos</b></div>
        <div class="right">
          <img src="assets/icons/news/pesos-2.svg" width="140" height="80" alt="pesos" />
        </div>
      </div>

      <div class="option" (click)="depositStep = 1; depositType = 0">
        <div class="left"><b>Dólares</b></div>
        <div class="right">
          <img src="assets/icons/news/dollars-2.svg" width="140" height="80" alt="dollars" />
        </div>
      </div>

      <div class="option" (click)="depositStep = 1; depositType = 2">
        <div class="left"><b>Crypto</b></div>
        <div class="right">
          <img src="assets/icons/news/crypto.svg" width="140" height="80" alt="crypto" />
        </div>
      </div>
    </div>
  </div>

  <app-fiat
    [isDepositDisabled]="isDepositDisabled"
    (backEvent)="back()"
    *ngIf="depositStep === 1 && depositType !== 2"
    [type]="depositType"
    [monthLimit]="monthLimit"
  ></app-fiat>

  <app-deposit-crypto
    [depositStep]="depositStep"
    (backEvent)="back()"
    *ngIf="depositStep >= 1 && depositType === 2"
  ></app-deposit-crypto>
</div>
